import { render } from "./SyncStatusPill.vue?vue&type=template&id=1d1c177a&scoped=true"
import script from "./SyncStatusPill.vue?vue&type=script&lang=js"
export * from "./SyncStatusPill.vue?vue&type=script&lang=js"

import "./SyncStatusPill.vue?vue&type=style&index=0&id=1d1c177a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d1c177a"]])

export default __exports__